import React, { Suspense, useEffect, useState } from "react";
import { ConfigProvider, Layout, Spin } from "antd";
import { LocalStorageKeys } from "../constants/localStorageKeys";
import * as localStorageService from "./../service/localStorageService";
import { useStore } from "./../store/store";
import './auth-layout.scss'
import { CommonConstants } from "../constants/commonConstants";
import { ErrorBoundary } from "./error-boundary/error-boundary";
import { Outlet } from "react-router-dom";
import { Content } from "antd/es/layout/layout";

export const PublicLayout=()=>{

    return <div>
    <Layout className="public-layout-wrapper">
            <ConfigProvider
              theme={{
                token: {
                  fontFamily: "Silka Regular",
                  colorPrimary: "#FF5D00",
                },
              }}
              direction={
                localStorageService.getValue(LocalStorageKeys.Lang) == CommonConstants.ArabicLanguageCode
                  ? "rtl"
                  : "ltr"
              }
            ></ConfigProvider>
            <ErrorBoundary>
            <Content className="content-body-wrapper">
                <Outlet />
            </Content>
            </ErrorBoundary>
            </Layout>
            </div>
}